import React from "react";
import {
  Box,
  Paper,
  Typography,
  Avatar,
  Divider,
} from "@mui/material";
import DescriptionIcon from "@mui/icons-material/Description";
import AccessTimeIcon from "@mui/icons-material/AccessTime";

// Mapping status to UI content
const statusMap = {
  leadReceived: {
    title: "Lead Inquiry Received",
    description: "Your inquiry has been received and logged in our system",
    timeframe: "Typical timeframe: Same day",
  },
  initialConsultation: {
    title: "Initial Discussion Underway",
    description: "We are arranging a consultation to understand your needs",
    timeframe: "Typical timeframe: 1-2 business days",
  },
  proposalSent: {
    title: "Proposal Sent",
    description: "A proposal has been shared outlining the services and pricing",
    timeframe: "Typical timeframe: 2-3 business days",
  },
  serviceAgreement: {
    title: "Service Agreement Pending",
    description: "Awaiting client confirmation on the service agreement",
    timeframe: "Awating Client decision",
  },
  paymentPending: {
    title: "Payment Pending",
    description: "Waiting for payment to be completed",
    timeframe: "Awating Client decision",
  },
  paymentReceived: {
    title: "Payment Received",
    description: "Payment has been received, services will begin shortly",
    timeframe: "Typical timeframe: Same day",
  },
  executionInProgress: {
    title: "Execution in Progress",
    description: "Your service/project is currently being executed",
    timeframe: "Typical timeframe: 5-10 business days",
  },
  serviceCompleted: {
    title: "Service Completed",
    description: "The service has been completed successfully",
    timeframe: "Complete",
  },
  postServiceSupport: {
    title: "Post-Service Support",
    description: "Ongoing support is available as per the agreement",
    timeframe: "Post Service Active",
  },
  followUpSent: {
    title: "Follow-Up Sent",
    description: "A follow-up has been sent to ensure satisfaction and next steps",
    timeframe: "Typical timeframe: 3-5 business days post-service",
  },
  awaitingDecision: {
    title: "Awaiting Client Decision",
    description: "Waiting for the client to make a decision regarding the proposal",
    timeframe: "Awating Client decision",
  },
  leadDormant: {
    title: "Lead Dormant",
    description: "No activity has been recorded for this lead",
    timeframe: "Dormant until re-engaged",
  },
};


export default function CurrentStatus({ status }) {
  // If no status or unknown, fallback to a default message
  const statusInfo =
    statusMap[status] || {
      title: "Status Unknown",
      description: "Unable to determine the current status. Please contact support.",
      timeframe: "",
    };

  return (
    <Paper
      sx={{
        p: 3,
        borderRadius: 3,
        border: 1,
        borderColor: "divider",
      }}
      elevation={1}
    >
      {/* Header */}
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={1}
      >
        <Typography variant="h6" fontWeight="600">
          Current Status
        </Typography>
        
      </Box>
      <Divider sx={{ mb: 2 }} />
      {/* Status details */}
      <Box display="flex" gap={2} alignItems="flex-start">
        {/* Icon */}
        <Avatar
          sx={{
            bgcolor: "#60CFDB",
            width: 64,
            height: 64,
          }}
        >
          <DescriptionIcon sx={{ color: "#FFFFFF", fontSize: 32 }} />
        </Avatar>

        {/* Text */}
        <Box flexGrow={1}>
          <Typography variant="subtitle1" fontWeight="600" mb={0.5}>
            {statusInfo.title}
          </Typography>
          <Typography variant="body2" color="text.secondary" mb={1.5}>
            {statusInfo.description}
          </Typography>
          {statusInfo.timeframe && (
            <Box display="flex" alignItems="center" gap={0.5} color="text.secondary">
              <AccessTimeIcon sx={{ fontSize: 16 }} />
              <Typography variant="caption">{statusInfo.timeframe}</Typography>
            </Box>
          )}
        </Box>
      </Box>
    </Paper>
  );
}
